/* Homepage quick add: native form fallback, then the store's existing cart refresh. */
(() => {
  'use strict';
  if (window.spHomeShopBound) return;
  window.spHomeShopBound = true;
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.sp-home-shop__native-form')) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button.disabled) return;
    const errorBox = form.parentElement.querySelector('[role="alert"]');
    const spinner = button.querySelector('.loading__spinner');
    errorBox.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');
    spinner.classList.remove('hidden');
    const root = window.Shopify?.routes?.root || '/';
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items: [{id: form.elements.id.value, quantity: 1}]}),
        signal: controller.signal
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'Nie udało się dodać produktu.');
      const drawer = document.querySelector('cart-drawer');
      // The store drawer owns its state and grouped products. A second generic
      // cartUpdate render can overwrite that list; use its public refresh/open path.
      if (drawer && typeof drawer.open === 'function') await drawer.open(button);
      else window.location.assign(root + 'cart');
    } catch (error) {
      const message = ['AbortError', 'TypeError'].includes(error.name)
        ? 'Nie udało się potwierdzić dodania. Sprawdź koszyk przed ponowną próbą.'
        : error.message;
      errorBox.querySelector('.product-form__error-message').textContent = message;
      errorBox.hidden = false;
    } finally {
      clearTimeout(timer);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.classList.remove('loading');
      spinner.classList.add('hidden');
    }
  });
})();
